import React from 'react';
import htmlStringImgUrlConverter from '@magento/peregrine/lib/util/htmlStringImgUrlConverter';

var toHTML = function toHTML(str) {
  return {
    __html: htmlStringImgUrlConverter(str)
  };
};

function PlainHtmlRenderer(_ref) {
  var html = _ref.html,
      classes = _ref.classes;

  // Even if empty, render a div with no content, for styling purposes.
  if (!html) {
    return React.createElement("div", {
      className: classes.root
    });
  }

  return React.createElement("div", {
    className: classes.root,
    dangerouslySetInnerHTML: toHTML(html)
  });
}

export var canRender = function canRender() {
  return true;
}; // backstop component, always renders

export var Component = PlainHtmlRenderer;